<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('my.online_service') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <div class="ksp-frame">
      <iframe
        frameborder="0"
        id="iframe_web"
        :src="iframeSrc"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    iframeSrc() {
      return this.$store.getters.getBaseInfo.kefu !== undefined
        ? this.$store.getters.getBaseInfo.kefu
        : 'https://hao.360.com/';
    }
  },
  methods: { back() { return window.history.back(); } },
  mounted() {
    const oIframe = document.getElementById('iframe_web');
    const h = document.documentElement.clientHeight;
    if (oIframe) oIframe.style.height = (Number(h) - 65) + 'px';
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
.ksp-frame {
  max-width: 900px; margin: 0 auto;
  padding: 10px 10px 0;
}
.ksp-frame iframe {
  width: 100%;
  border-radius: 16px;
  border: 1px solid rgba(255,77,141,.12);
  box-shadow: 0 6px 18px rgba(255,77,141,.08);
  background: #fff;
}
</style>
